import { HistoryListProps } from "@husky-x/history-list";

export const HistoryMock: HistoryListProps  = {
	data: [
		{
			year: 1915,
			description: 'LA Jackson funda a London Rubber Company e vende preservativos importados e acessórios para barbearias.',
		},
		{
			year: 1929,
			description: 'A London Rubber Company (LRC) regista a marca Durex.',
		},
		{
			year: '1950er',
			description: 'A Durex lança o seu primeiro preservativo lubrificado.',
		},
		{
			year: 1953,
			description: 'A Durex é a primeira marca a desenvolver e usar testes electrónicos.',
		},
		{
			year: '1960er',
			description: 'A Durex lança o primeiro preservativo com forma anatómica do mundo.',
		},
		{
			year: '1970er',
			description: 'A Durex é a primeira marca de preservativos a comunicar em diferentes países.',
		},
		{
			year: '1990er',
			description: 'A Durex é a primeira marca de preservativos a adotar o “selo de qualidade” global como norma.',
		},
		{
			year: 1995,
			description: 'A Durex introduz uma gama de preservativos coloridos e com sabor.',
		},
		{
			year: 1996,
			description: 'A Durex é a primeira marca de preservativos a lançar um website. Nos dias de hoje, temos 42 sites diferentes para os países em que comercializamos.',
		},
		{
			year: 1997,
			description: 'A Durex lança os preservativos sem látex: um novo material que não causa alergias é usado – poliuretano sintético desenvolvido pela Durex que é mais suave e mais elástico que o látex de borracha natural.',
		},
		{
			year: 1998,
			description: 'A Durex é a primeira marca de preservativos a realizar e publicar uma pesquisa global sobre bem-estar sexual.',
		},
		{
			year: 2001,
			description: 'A Durex lança o Pleasuremax. Isso faz da Durex a primeira marca de preservativos a comercializar um preservativo que combina texturas com pontos e estrias.',
		},
		{
			year: 2003,
			description: 'A Durex lança uma gama excitante de lubrificantes Play.',
		},
		{
			year: 2005,
			description: 'A Durex Network lança os relatórios “Face of Global Sex”, que exploram aspetos do comportamento sexual, criados com fins académicos e políticos.',
		},
		{
			year: 2008,
			description: 'De forma a promover o sexo seguro entre jovens, a Durex apelou aos jovens com idades compreendidas entre os 16 e 24 anos para desenharem um poster único sobre a saúde sexual – um poster criado por eles, para eles.',
		},
		{
			year: 2010,
			description: 'A Durex apoia “Condomize!”, uma iniciativa do Fundo de População das Nações Unidas, na Conferência Internacional de HIV/AIDS em Viena, doando 220.000 preservativos.',
		},
		{
			year: 2010,
			description: 'A Durex é comprada pela Reckitt Benckiser.',
		},
		{
			year: 2010,
			description: 'A Durex apresenta o Performax Intense, um preservativo projetado para ajudar os dois a chegarem ao orgasmo em simultâneo. Com benzocaína no interior do preservativo e formas estimulantes no exterior, para tornar o sexo mais intenso e ajudá-lo a durar mais.',
		},
		{
			year: 2019,
			description: 'A Durex faz 90 anos!',
		},
		{
			year: 2022,
			description: 'Durex apresenta a sua nova identidade.',
		},
	]
}